import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["id"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { find, get } from 'lodash';
import { useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
import { EAvailabilityStatus } from '@lumahealthhq/ui-model-types';
export var useAvailabilityBook = function useAvailabilityBook() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var id, params, payload, _yield$axiosClient$pu, data, availabilityAsArray, updatedAvailability;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id, params = _ref.params, payload = _ref.payload;
            _context.next = 3;
            return axiosClient.put("/availabilities/".concat(id, "/book"), payload, {
              params: params
            });
          case 3:
            _yield$axiosClient$pu = _context.sent;
            data = _yield$axiosClient$pu.data;
            availabilityAsArray = data == null ? void 0 : data.availabilities;
            if (!(availabilityAsArray != null && availabilityAsArray.length)) {
              _context.next = 9;
              break;
            }
            updatedAvailability = find(availabilityAsArray, function (it) {
              return id === it._id;
            });
            return _context.abrupt("return", updatedAvailability != null ? updatedAvailability : data);
          case 9:
            return _context.abrupt("return", data);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchFn(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['availabilities'], function (params) {
    return fetchFn(params);
  });
  return mutationResult;
};
export function useAvailabilityLock() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var id, payload, _yield$axiosClient$pu2, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = _ref3.id, payload = _objectWithoutProperties(_ref3, _excluded);
            _context2.next = 3;
            return axiosClient.put("/scheduler/availabilities/".concat(id, "/lock"), _extends({}, payload));
          case 3:
            _yield$axiosClient$pu2 = _context2.sent;
            data = _yield$axiosClient$pu2.data;
            return _context2.abrupt("return", _extends({}, data, {
              _id: id
            }));
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchFn(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['lock-availability'], function (params) {
    return fetchFn(params);
  });
  return mutationResult;
}
var INITAL_PARAMS = {
  includeNullApptTypes: true,
  realtime: true,
  status: EAvailabilityStatus.Available
};
export function useAvailabilityRTA() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var availability, params, _yield$axiosClient$ge, data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            availability = _ref5.availability;
            params = _extends({}, INITAL_PARAMS, {
              appointmentType: get(availability, 'appointmentType._id', null),
              date: [">=".concat(get(availability, 'date', '')), "<".concat(get(availability, 'endDate', ''))],
              facility: get(availability, 'facility._id', null),
              provider: get(availability, 'provider._id', null)
            }); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            _context3.next = 4;
            return axiosClient.get("v2/availabilities/scheduler", {
              params: params
            });
          case 4:
            _yield$axiosClient$ge = _context3.sent;
            data = _yield$axiosClient$ge.data;
            return _context3.abrupt("return", _extends({}, data));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function fetchFn(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['rta-availability'], function (params) {
    return fetchFn(params);
  });
  return mutationResult;
}